<template>
  <div class="image-grid-page">
    <h1 class="page-title">Unfiltered Images ({{ images.length }})</h1>
    <div class="grid">
      <div v-for="img in images" :key="img.filename" class="grid-cell">
        <img :src="`/images/unfiltered/${img.filename}`" :alt="img.filename" />
        <span class="label">{{ img.number }}</span>
      </div>
    </div>
  </div>
</template>

<script setup>
const filenames = [
  'forever_x_01.jpg','forever_x_02.jpg','forever_x_03.jpg','forever_x_04.jpg',
  'forever_x_05.jpg','forever_x_06.jpg','forever_x_07.jpg','forever_x_08.jpg',
  'forever_x_09.jpg','forever_x_10.jpg','forever_x_11.jpg','forever_x_12.jpg',
  'forever_x_13.jpg','forever_x_14.jpg','forever_x_15.jpg','forever_x_16.jpg',
  'forever_x_17.jpg','forever_x_18.jpg','forever_x_19.jpg','forever_x_20.jpg',
  'forever_x_21.jpg','forever_x_22.jpg','forever_x_23.jpg','forever_x_24.jpg',
  'forever_x_25.jpg','forever_x_26.jpg','forever_x_27.jpg','forever_x_28.jpg',
  'forever_x_29.jpg','forever_x_30.jpg','forever_x_31.jpg','forever_x_32.jpg',
  'forever_x_33.jpg','forever_x_34.jpg','forever_x_35.jpg','forever_x_36.jpg',
  'forever_x_37.jpg','forever_x_38.jpg','forever_x_39.jpg','forever_x_40.jpg',
  'forever_x_42.jpg','forever_x_43.jpg','forever_x_44.jpg','forever_x_46.jpg',
  'forever_x_49.jpg','forever_x_51.jpg','forever_x_52.jpg','forever_x_53.jpg',
  'forever_x_55.jpg','forever_x_56.jpg','forever_x_57.jpg','forever_x_58.jpg',
  'forever_x_59.jpg','forever_x_61.jpg','forever_x_62.jpg','forever_x_63.jpg',
  'forever_x_64.jpg','forever_x_65.jpg','forever_x_66.jpg','forever_x_67.jpg',
  'forever_x_68.jpg','forever_x_70.jpg','forever_x_71.jpg','forever_x_72.jpg',
  'forever_x_73.jpg','forever_x_74.jpg','forever_x_75.jpg','forever_x_76.jpg',
  'forever_x_77.jpg','forever_x_78.jpg','forever_x_79.jpg','forever_x_80.jpg',
  'forever_x_81.jpg','forever_x_82.jpg','forever_x_83.jpg','forever_x_84.jpg',
  'forever_x_85.jpg','forever_x_86.jpg','forever_x_87.jpg','forever_x_88.jpg',
  'forever_x_89.jpg','forever_x_90.jpg',
]

const images = filenames.map(filename => ({
  filename,
  number: parseInt(filename.match(/(\d+)\.jpg$/)[1], 10)
}))
</script>

<style scoped>
.image-grid-page {
  padding: 16px;
  background: #111;
  min-height: 100vh;
}

.page-title {
  color: #fff;
  font-size: 1rem;
  margin-bottom: 16px;
  font-family: monospace;
}

.grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 8px;
}

.grid-cell {
  position: relative;
  aspect-ratio: 11 / 6;
  overflow: hidden;
  background: #222;
}

.grid-cell img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.label {
  position: absolute;
  top: 6px;
  left: 8px;
  background: rgba(0, 0, 0, 0.65);
  color: #fff;
  font-family: monospace;
  font-size: 0.85rem;
  font-weight: bold;
  padding: 2px 6px;
  border-radius: 3px;
  line-height: 1.4;
  pointer-events: none;
}
</style>
